import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

export const MIN_PACKAGE_YEAR = 2000;

export const TIME_SLOTS = Array.from({ length: 96 }, (_, i) => {
  const hours = String(Math.floor(i / 4)).padStart(2, "0");
  const minutes = String((i % 4) * 15).padStart(2, "0");
  return `${hours}:${minutes}`;
});

export function parseDateText(text: string): string | null {
  const parsed = dayjs(text.trim(), ["YYYY/MM/DD", "YYYY/M/D"], true);
  return parsed.isValid() && parsed.year() >= MIN_PACKAGE_YEAR
    ? parsed.format("YYYY-MM-DD")
    : null;
}

export function toDisplayDate(date: string | null): string {
  if (!date) return "";
  const parsed = dayjs(date);
  return parsed.isValid() ? parsed.format("YYYY/MM/DD") : "";
}

export function parseTimeText(text: string): string | null {
  const parsed = dayjs(text.trim(), ["HH:mm", "H:mm"], true);
  return parsed.isValid() ? parsed.format("HH:mm") : null;
}

export function formatDateTime(date: string | null, time = ""): string {
  if (!date) return time;
  return `${toDisplayDate(date)} ${time}`;
}

export function formatDateTimeRange(
  startDate: string | null,
  startTime: string,
  endDate: string | null,
  endTime: string,
): string {
  return `${formatDateTime(startDate, startTime)} ~ ${formatDateTime(
    endDate,
    endTime,
  )}`;
}

export function createDateFromComponents(
  date: string | null,
  time: string,
): Date {
  if (!date) return new Date(0);
  return dayjs.tz(`${date} ${time ?? "00:00"}`, "Asia/Tokyo").toDate();
}

export function parseDateTime(dateTime: string | number | null | undefined): {
  date: string | null;
  time: string;
} {
  if (!dateTime) return { date: null, time: "" };
  const timestamp = typeof dateTime === "number" ? dateTime * 1000 : dateTime;
  const jstDateTime = dayjs
    .utc(timestamp)
    .tz("Asia/Tokyo")
    .format("YYYY-MM-DD HH:mm");
  const [date, time] = jstDateTime.split(" ");
  return { date, time };
}

export function validateDateTimeRange(
  startDate: string | null,
  startTime: string,
  endDate: string | null,
  endTime: string,
): boolean {
  if (!startDate || !startTime || !endDate || !endTime) {
    return false;
  }
  const startDateTime = createDateFromComponents(startDate, startTime);
  const endDateTime = createDateFromComponents(endDate, endTime);
  return endDateTime >= startDateTime;
}
